module.exports = __webpack_public_path__ + "img/foto_Zoe.79d564a6.jpg";